// @ts-nocheck

import { sha256 } from 'js-sha256';

import { EMAIL_LOCAL_STORAGE_KEY, PHONE_LOCAL_STORAGE_KEY, USER_ID_LOCAL_STORAGE_KEY } from 'constants/session';
import { getOrCreateLoggedOutUserId, getStoredCid, hashUserEmail } from 'utils/analytics/analyticsProvider';
import { getCookie, getLocalStorageWithExpiration } from 'utils/storage';

export const loadGTM = (): void => {
    // Initialize the TradingView tag stub to prevent ReferenceError from GTM tags before its script loads.
    if (typeof window !== 'undefined') {
        if (!window.tvtag) {
            window.tvtag = function () {
                (window.tvtag.q = window.tvtag.q || []).push(arguments);
            };
        }
    }

    (function (w, d, s, l, i): void {
        w[l] = w[l] || [];
        // Add cid to dataLayer
        try {
            const storedCid = getStoredCid();
            if (storedCid) {
                w[l].push({ cid: storedCid });
            }
            const userId = getLocalStorageWithExpiration(USER_ID_LOCAL_STORAGE_KEY);
            const externalId = userId || getOrCreateLoggedOutUserId();
            if (externalId) {
                w[l].push({
                    external_id: externalId,
                    is_registered_user: !!userId,
                });
            }
            const email = getLocalStorageWithExpiration(EMAIL_LOCAL_STORAGE_KEY);
            if (email) {
                const hashedEmail = hashUserEmail(email);
                w[l].push({ em: hashedEmail });
            }
            const phone = getLocalStorageWithExpiration(PHONE_LOCAL_STORAGE_KEY);
            if (phone) {
                const hashedPhone = sha256(phone);
                w[l].push({ ph: hashedPhone });
            }
            const referral = getCookie('kalshi_referral');
            if (referral) {
                w[l].push({ referral });
            }
        } catch (e) {
            /* Fail silently */
        }

        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // eslint-disable-next-line  prefer-const
        let f = d.getElementsByTagName(s)[0],
            // eslint-disable-next-line  prefer-const
            j = d.createElement(s),
            // eslint-disable-next-line  prefer-const
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        if (f) {
            f.parentNode.insertBefore(j, f);
        }
    })(window, document, 'script', 'dataLayer', 'GTM-NP66QTXD');
};
